import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { DirectivesModule } from '@library/ui/directives/directives.module';
import { PreviewGraphComponent } from '@library/ui/molecules/preview-graph/preview-graph.component';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { WeathermapFacade } from '@store/weathermap.facade';

@Component({
  selector: 'app-humidity-card',
  imports: [
    PreviewGraphComponent,
    TextModule,
    AsyncPipe,
    PipesModule,
    DirectivesModule,
  ],
  templateUrl: './humidity-card.component.html',
  styleUrl: './humidity-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HumidityCardComponent {
  type = EnumMeasureTypes.HUMIDITY;

  station = this.weathermapFacade.selectedStation;

  constructor(
    private readonly weathermapFacade: WeathermapFacade,
  ) {}

  getValue(): number {
    return this.station().Humidity?.[this.station().Humidity?.length - 1].y ?? null;
  }
}
